export default "__VITE_ASSET__34d96c90__"